module.exports = __webpack_public_path__ + "8790a1dfadfec54907b005d29ba02f.svg";